import { useQuery, gql } from "utils/urql";
import Image from "components/Image";
import SectionHeading from "components/homepage/SectionHeading";
import { HomepageWritersQuery } from "types/api";
import styles from "./Writers.module.scss";

const query = gql`
  query HomepageWriters {
    curatedAuthorGroup(slug: "top-authors") {
      id
      displayName
      river(first: 12) {
        edges {
          id
          node {
            displayName
            url
            headshot(width: 60, height: 60, sizes: ["1x", "2x"]) {
              url
              srcSet
              altText
              width
              height
            }
            river(first: 1) {
              edges {
                node {
                  title
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`;

const Writers = () => {
  const [{ data }] = useQuery<HomepageWritersQuery>({
    query,
  });

  if (!data) return null;

  const writerList = data.curatedAuthorGroup.river.edges;

  return (
    <section className={styles.root}>
      <SectionHeading
        analyticsSlug="writers"
        secondaryLinkText="see all"
        title="Writers"
        url="https://www.theatlantic.com/writers/"
      />
      <div className={styles.overflowContainer}>
        <ul className={styles.writersContainer}>
          {writerList.map((writer, idx) => (
            <li className={styles.writer} key={writer.id}>
              {writer.node.headshot && (
                <Image
                  className={styles.headshot}
                  alt={writer.node.headshot.altText}
                  src={writer.node.headshot.url}
                  srcSet={writer.node.headshot.srcSet}
                  lazy
                  width={writer.node.headshot.width}
                  height={writer.node.headshot.height}
                />
              )}
              <div className={styles.writerInfo}>
                <a
                  className={styles.writerName}
                  href={writer.node.url}
                  data-action={`click link - writers - author ${idx + 1}`}
                >
                  {writer.node.displayName}
                </a>
                <a
                  className={styles.writerArticle}
                  href={writer.node.river.edges[0].node.url}
                  dangerouslySetInnerHTML={{
                    __html: writer.node.river.edges[0].node.title,
                  }}
                  data-action={`click link - writers - title ${idx + 1}`}
                ></a>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.scroll}>Scroll →</div>
    </section>
  );
};

export default Writers;
